class SeyMegaMenuTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-sey-mega-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-sey-mega-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activate(tab.getAttribute('data-sey-mega-tab'));
      });

      tab.addEventListener('mouseenter', () => {
        if (!this.isDesktopHover()) return;
        this.activate(tab.getAttribute('data-sey-mega-tab'));
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        const nextIndex =
          event.key === 'ArrowDown'
            ? (index + 1) % this.tabs.length
            : (index - 1 + this.tabs.length) % this.tabs.length;

        this.tabs[nextIndex].focus();
        this.activate(this.tabs[nextIndex].getAttribute('data-sey-mega-tab'));
      });
    });
  }

  isDesktopHover() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.matchMedia('(min-width: 990px)').matches
    );
  }

  activate(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-sey-mega-tab') === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-sey-mega-panel') === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

customElements.define('sey-mega-menu-tabs', SeyMegaMenuTabs);
